import {Controller} from '@hotwired/stimulus';

/**
 * Demande confirmation, par la boîte `confirm()` du navigateur, avant l'envoi du formulaire qui le porte.
 *
 *   <form {{ stimulus_controller('submit-confirm', {message: 'cle'|trans})
 *         |stimulus_action('submit-confirm', 'confirm', 'submit') }}>
 *
 * Refuser annule l'envoi et arrête l'événement, que n'interceptent donc ni `fetch-frame` ni un autre
 * écouteur de `submit` placé plus haut. `form.submit()` n'émet pas l'événement `submit` et n'est donc pas confirmé :
 * envoyer par un bouton d'envoi ou par `form-submit#requestSubmit`.
 */
export default class extends Controller {
  static values = {message: String};

  confirm(event) {
    if (!window.confirm(this.messageValue)) {
      event.preventDefault();
      event.stopImmediatePropagation();
    }
  }
}
